import React, { useEffect, useState, useContext } from "react";
import Navbar from "./Navbar";
import Banner from "./Banner";
import Axios from "axios";
import { useHistory, Link } from "react-router-dom";
import StateContext from "../StateContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import LazyLoad from "react-lazy-load";
import LoaderAnimation from "./LoaderAnimation";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Button, IconButton } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import {
  RangeDatePicker,
  SingleDatePicker,
} from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { responsiveFontSizes } from "@mui/material";
import { getCookie } from "../Functions/cookieFunction";
import { handleError } from "../Functions/getAlert";
import DispatchContext from "../DispatchContext";

const Loading = () => {
  <div className="post loading">
    <h5>Loading ...</h5>
  </div>;
};
const Transactions = (props) => {
  // // // console.log(props);
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [seeMore, setSeeMore] = useState(5);
  const [transHistory, setTransHistory] = useState([]);
  const [walletHistory, setWalletHistory] = useState([]);
  // // // console.log(walletHistory)

  // sikandar

  const [searchTransactionArr, setsearchTransactionArr] = useState([]);
  const [showfilterTransaction, setshowfilterTransaction] = useState(false);
  const [showDatePicker, setshowDatePicker] = useState(true);
  const [filterData, setFilterData] = useState([]);
  const [MainTransactionState, setMainTransactionState] = useState([]);
  const [ApiHitKeyword, setApiHitKeyword] = useState("current");
  // // // console.log(ApiHitKeyword);

  useEffect(() => {
    const walletHistoryForFilteration = async () => {
      setIsLoading(true);
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}transaction/current`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );
        setIsLoading(false);
        setFilterData(response.data.data.reverse());
        setTransHistory(response.data.data);
      } catch (e) {
        handleError(e, appDispatch);
      }
    };
    walletHistoryForFilteration();
  }, []);

  const searchTransactionFunc = (e) => {
    if (e.target.value.length > 0) {
      setshowfilterTransaction(true);
    } else {
      setshowfilterTransaction(false);
    }
    const filterTransactions = filterData.filter(
      (sr) => sr.created_at.indexOf(e.target.value) > -1
    );
    setsearchTransactionArr(filterTransactions.reverse());
    props.setCount(filterTransactions.length);
  };

  const [TransactionType, setTransactionType] = useState("AllTransactions");
  // // // console.log(TransactionType)
  useEffect(() => {
    if (TransactionType == "AllTransactions") {
      setApiHitKeyword("current");
      setshowDatePicker(true);
    } else if (TransactionType == "OneDayTransactions") {
      setApiHitKeyword("last24hours");
      setshowDatePicker(true);
    } else if (TransactionType == "OneWeekTransactions") {
      setApiHitKeyword("currentWeek");
      setshowDatePicker(true);
    } else if (TransactionType == "OneMonthTransactions") {
      setApiHitKeyword("currentMonth");
      setshowDatePicker(true);
    } else if (TransactionType == "OneYearTransactions") {
      setApiHitKeyword("currentYear");
      setshowDatePicker(true);
    }
  }, [TransactionType]);

  useEffect(() => {
    const fetchTransactionByKeyWord = async () => {
      setIsLoading(true);

      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}transaction/${ApiHitKeyword}`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        setIsLoading(false);
        setMainTransactionState(response.data.data.reverse());
        setTransHistory(response.data.data);

        props.setCount(response.data.data.length);
      } catch (e) {
        handleError(e, appDispatch);
      }
    };
    fetchTransactionByKeyWord();
  }, [ApiHitKeyword]);

  const onDateChange = async (startDate, endDate) => {
    // event.preventDefault();

    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}transaction/filter`,
        {
          from: startDate,
          to: endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setIsLoading(false);
      setMainTransactionState(response.data.data.reverse());
      setTransHistory(response.data.data);
      props.setCount(response.data.data.length);
    } catch (e) {
      handleError(e, appDispatch);
    }
  };

  const handleSeeMore = () => {
    let count = seeMore + 5;
    if (count < transHistory.length) {
      setSeeMore(count);
    } else if (count > transHistory.length) {
      setSeeMore(transHistory.length);
    }
  };

  if (!appState.loggedIn) {
    history.push("/");
  }

  return (
    <>
      <div className="data-content__dashboard">
        <div className="data-row__dashboard">
          <Stack>
            {isLoading ? (
              <div style={{ position: "relative", height: "250px" }}>
                <LoaderAnimation />
              </div>
            ) : (
              <>
                <div className="container">
                  <div className="row d-flex justify-content-center">
                    <div className="col-sm-10">
                      <div className="row d-flex justify-content-between align-items-center  pl-0 pr-0 dashboardSearchTransac">
                        <div className="col-sm-6 mt-2">
                          <TextField
                            onChange={(e) => searchTransactionFunc(e)}
                            fullWidth
                            label="search your transactions"
                            id="fullWidth"
                          />
                        </div>

                        <div className="col-sm-6 d-flex align-items-center">
                          <div className=" TransactionMaintabs w-100 py-1 mt-2">
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              variant="scrollable"
                              scrollButtons
                              aria-label="visible arrows tabs example"
                              sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                  "&.Mui-disabled": { opacity: 0.3 },
                                },
                              }}
                            >
                              <Tab
                                onClick={() =>
                                  setTransactionType("AllTransactions")
                                }
                                label="ALL"
                              />

                              <Tab
                                onClick={() =>
                                  setTransactionType("OneDayTransactions")
                                }
                                label="D"
                              />
                              <Tab
                                onClick={() =>
                                  setTransactionType("OneWeekTransactions")
                                }
                                label="W"
                              />
                              <Tab
                                onClick={() =>
                                  setTransactionType("OneMonthTransactions")
                                }
                                label="M"
                              />
                              <Tab
                                onClick={() =>
                                  setTransactionType("OneYearTransactions")
                                }
                                label="Y"
                              />
                              <Tab
                                onClick={() =>
                                  setshowDatePicker(!showDatePicker)
                                }
                                label={
                                  <i
                                    class="fa fa-sliders"
                                    aria-hidden="true"
                                  ></i>
                                }
                              />
                            </Tabs>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container ">
                  <div className="row d-flex justify-content-center ">
                    <div className="col-sm-10 mt-3">
                      <div className={showDatePicker ? "displayNone" : ""}>
                        <RangeDatePicker
                          onChange={(startDate, endDate) =>
                            onDateChange(startDate, endDate)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {MainTransactionState.length > 0 ? (
                  <>
                    <div className="row d-flex justify-content-center m-0">
                      {showfilterTransaction
                        ? searchTransactionArr
                            .slice(0, seeMore)
                            .map((wallet, index) => {
                              return (
                                <div className="col-md-8 px-0" key={index}>
                                  <LazyLoad
                                    height={"100%"}
                                    placeholder={<Loading />}
                                  >
                                    <HistoryRow
                                      data_id={wallet.id}
                                      amount={wallet.amount}
                                      status={wallet.status}
                                      received_by={wallet.received_by}
                                      sent_by={wallet.sent_by}
                                      created={wallet.created_at}
                                      source={wallet.source}
                                    />
                                  </LazyLoad>
                                </div>
                              );
                            })
                        : MainTransactionState.slice(0, seeMore).map(
                            (wallet, index) => {
                              // // // console.log(searchTransactionArr.length)
                              return (
                                <div className="col-md-8 px-0" key={index}>
                                  <LazyLoad
                                    height={"100%"}
                                    placeholder={<Loading />}
                                  >
                                    <HistoryRow
                                      data_id={wallet.id}
                                      amount={wallet.amount}
                                      status={wallet.status}
                                      received_by={wallet.received_by}
                                      sent_by={wallet.sent_by}
                                      created={wallet.created_at}
                                      source={wallet.source}
                                    />
                                  </LazyLoad>
                                </div>
                              );
                            }
                          )}
                    </div>
                  </>
                ) : (
                  <NoTransactions />
                )}

                <div className="col-12 d-flex justify-content-center mb-2">
                  {seeMore < MainTransactionState.length ? (
                    <Button
                      className="seeMoreBtn"
                      variant="text"
                      onClick={handleSeeMore}
                    >
                      {" "}
                      {"See More"}{" "}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </Stack>
        </div>
      </div>
    </>
  );
};
function NoTransactions() {
  // const appState = useContext(StateContext)
  return (
    <>
      <div className="empBox">
        <div className="text-center py-5">
          {/* BoxImg */}
          <div className="BoxImg">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}box.png`}
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="mt-1">
            <p classsName="text-secondary">
              <strong>You don't have any deposits</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
function HistoryRow(props) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  // // // console.log("ssssssss", props.source);
  const history = useHistory();

  return (
    <>
      <div className="post">
        <a
          href={
            props.source === "Invoice"
              ? `https://${window.location.host}/invoice/in/${props.data_id}`
              : "#"
          }
          target={props.source === "Invoice" ? `_blank` : ``}
        >
          <div className="data-row" id={"dep"}>
            <div className="row m-0 align-items-center">
              <div className="col-3 pl-0">
                {props.source === "Invoice" ? (
                  <div className="row m-0  pl-3 ">
                    <div className="text pl-2">
                      <p className="text-muted m-0 small">
                        {t("dashboard.sent-by")}dd
                      </p>
                      <h6 className="m-0">{props.sent_by}</h6>
                    </div>{" "}
                  </div>
                ) : (
                  <div className="row m-0 align-items-center pl-3 ">
                    <div className="text pl-2">
                      <h6 className="m-0">Top Up at walllet</h6>
                    </div>{" "}
                  </div>
                )}
              </div>

              <div className="col-3 text-center p-0">
                <div className="data-row__payment_method_time">
                  <div className="row m-0 justify-content-center align-items-center">
                    <div className="row m-0 text-left align-items-center justify-content-center text-center">
                      <div className="payment_method_icon">
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}calendar.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div>
                        <p className="small text-muted m-0 text-uppercase">
                          {t("dashboard.processed-on")}
                        </p>
                        <h6 className="time m-0">
                          <strong>{props.created}</strong>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`${
                  appState.langValue === "ar" ? "pl-4" : "text-right"
                } col-3 p-0`}
              >
                <div className="data-row__price">
                  <h5>
                    <strong
                      className={`${
                        props.status == "Success"
                          ? props.source == "Invoice"
                            ? "text-red"
                            : "text-green"
                          : ""
                      }`}
                    >
                      {parseFloat(props.amount).toFixed(3)} {t("KWD")}
                    </strong>
                  </h5>
                  <p className="text-muted m-0 small">
                    {" "}
                    {t("dashboard.source")}
                  </p>
                  <h6 className="m-0">{props.source}</h6>
                  <div>
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}${props.status}.png`}
                      className="img-fluid"
                      width="30"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div
                className={`${
                  appState.langValue === "ar" ? "pl-4" : "text-right"
                } col-3 p-0`}
              >
                <div className="data-row__price">
                  <h5>
                    <strong>Status</strong>
                  </h5>
                  <p
                    className={`${
                      props.status == "Success"
                        ? "text-green"
                        : props.status == "Pending"
                        ? "text-orange"
                        : " text-red"
                    } m-0 small status`}
                  >
                    {" "}
                    {props.status}
                  </p>

                  <div>
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}${props.status}.png`}
                      className="img-fluid"
                      width="30"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
}

export default withTranslation()(Transactions);
